import { createAction, props } from '@ngrx/store';

import { Order } from './orders.models';

export const createOrder = createAction('[Order] Create');

export const createOrderSuccess = createAction('[Order] Create Success', props<{ order: Order }>());

export const createOrderFailure = createAction('[Order] Create Failure', props<{ error: string }>());
